export default __webpack_public_path__ + "static/media/quote.197d6d72.svg";